module.exports = __webpack_public_path__ + "img/dress-to-progress.adb9ff8b.png";